import React, { useEffect } from 'react'
import { formatSessionTime } from '../game/model/session'
import { useGameStore } from '../store/gameStore'

export const GameMenu: React.FC = () => {
  const { resumeGame, resetGame, sessionView } = useGameStore()

  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape' || event.key === ' ') {
        event.preventDefault()
        resumeGame()
      }
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [resumeGame])

  return (
    <div className="bg-slate-800/95 backdrop-blur-sm rounded-xl p-8 max-w-md mx-4 border border-slate-700 shadow-2xl">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-yellow-400 mb-2">Game Paused</h2>
        <p className="text-slate-300 text-sm">
          The simulation is stopped
        </p>
      </div>

      <div className="space-y-3">
        <button
          onClick={resumeGame}
          className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-200 shadow-lg hover:shadow-green-600/25"
        >
          Resume Game
        </button>

        <button
          onClick={resetGame}
          className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-200 shadow-lg hover:shadow-red-600/25"
        >
          Main Menu
        </button>
      </div>

      <div className="mt-6 p-4 bg-slate-900/50 rounded-lg border border-slate-700">
        <h3 className="text-sm font-semibold text-slate-300 mb-2">Quick Stats</h3>
        <div className="space-y-1 text-xs">
          <div className="flex justify-between">
            <span className="text-slate-400">Lives:</span>
            <span className="text-slate-300">{sessionView?.lives ?? 0}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-slate-400">Coins:</span>
            <span className="text-slate-300">{sessionView?.gold ?? 0}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-slate-400">Session Time:</span>
            <span className="text-slate-300">{formatSessionTime(sessionView?.elapsedTime ?? 0)}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-slate-400">Enemies Defeated:</span>
            <span className="text-slate-300">{sessionView?.defeatedEnemies ?? 0}</span>
          </div>
        </div>
      </div>
    </div>
  )
}
